import type { QueryClient } from '@tanstack/react-query';

/** Platform-wide queries that must not refetch on tenant switch. */
const PLATFORM_QUERY_KEYS = new Set(['platform-tenants-switcher', 'tenants']);

/**
 * Invalidate cached API data when the active tenant context changes.
 * Keeps platform tenant list queries intact.
 */
export function invalidateTenantQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: (query) => {
      const root = query.queryKey[0];
      return typeof root === 'string' && !PLATFORM_QUERY_KEYS.has(root);
    },
  });
}
